<rt-dropdown class="dropdown">
  <rt-dropdown-header *ngIf="showHeader" (mousedown)="goBack($event)" class="header">
    <div layout layout-align-items-center>
      <rt-icon name="arrow-back" margin-right-small-x></rt-icon>
      {{ placeholderCategoryTranslationMap[category].name }}
    </div>
  </rt-dropdown-header>
  <rt-dropdown-item
    *ngFor="let placeholder of placeholdersByCategory; let isLast = last; trackBy: trackByName"
    [insertPlaceholder]="placeholder.id"
    [insertPlaceholderTarget]="activeTarget!"
    [flexColumn]="true"
    (click)="select.emit(placeholder)"
    layout-vertical
  >
    <rt-heading variant="heading">
      <span class="preserve-whitespace" margin-right-small-xx text-primary>[ </span>
      {{ withoutBrackets(placeholder.id) }}
      <span class="preserve-whitespace" margin-left-small-xx text-primary> ]</span>
    </rt-heading>
    <span
      [innerHTML]="placeholder.interpolated ? placeholder.value : placeholder.data.description"
      class="description"
    >
    </span>
  </rt-dropdown-item>
</rt-dropdown>
